import { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

import { trackOfferPageHotelFlightsCtaImpression } from 'components/OfferPage/analytics'

export default function useHotelFlightsCtaImpression(hasDisplayPriceAndCta: boolean, enabled = true) {
  const [ref, inView] = useInView({
    skip: !enabled,
    threshold: 0.5,
    triggerOnce: true,
  })
  const trackedRef = useRef(false)

  useEffect(() => {
    if (!enabled || !inView || trackedRef.current) {
      return
    }

    trackOfferPageHotelFlightsCtaImpression(hasDisplayPriceAndCta)
    trackedRef.current = true
  }, [enabled, hasDisplayPriceAndCta, inView])

  return ref
}
